/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import FlagContent from 'bundles/content-feedback/components/cds/flag/FlagContent';
import type { Comments } from 'bundles/content-feedback/components/cds/flag/types';
import type { ItemType } from 'bundles/content-feedback/constants/ItemTypes';
import type { ComputedItemType } from 'bundles/learner-progress/lib/ComputedItem';
import type { Item } from 'bundles/learner-progress/types/Item';

type Props = {
  computedItem: Item | ComputedItemType;
  selected: boolean;
  onSelect: () => void;

  itemFeedbackType: ItemType;
  tooltipPlacement: string;
  comments: Comments;
  onSubmit: (comments: Comments) => void;
  onRemove: (comments: Comments) => void;
  onCancel?: () => void;
};

const styles = {
  root: css`
    margin-right: var(--cds-spacing-200);
  `,
};

const Flag: React.FC<Props> = ({
  selected,
  computedItem,
  itemFeedbackType,
  comments,
  onSelect,
  onSubmit,
  onRemove,
  onCancel,
}) => {
  return (
    <div css={styles.root}>
      <FlagContent
        computedItem={computedItem}
        itemFeedbackType={itemFeedbackType}
        comments={comments}
        onSelect={onSelect}
        onSubmit={onSubmit}
        onRemove={onRemove}
        selected={selected}
        onCancel={onCancel}
      />
    </div>
  );
};

export default Flag;
